import { Box, Typography } from "@mui/material"
import { DataNode } from "graphql/types"
import Markdown from "markdown-to-jsx"

type ReportNodeTextBoxProps = {
  data: DataNode
}

export const ReportNodeTextBox = (props: ReportNodeTextBoxProps) => {
  const { data } = props
  return (
    <Box sx={{ width: "100%" }}>
      {data.text !== "" ? (
        <Box sx={{ mb: 1 }}>
          <Markdown>{data.text}</Markdown>
        </Box>
      ) : (
        <Typography sx={{ backgroundColor: "red", mb: 1 }}>
          Bitte Text einfügen
        </Typography>
      )}
    </Box>
  )
}
